import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInformationService {

  public readonly author: string;

  public readonly name: string;

  public readonly version: string;

  public readonly date: Date;

  public constructor() {
    this.author = require('package.json').author;
    this.name = require('package.json').name;
    this.version = require('package.json').version;
    this.date = new Date();
  }

}
